<template>
    <div>

        <vue-headful title="Delete Disciplinary Action :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/employees/disciplinary-actions`">
                        <i class="fa fa-gavel"></i> Disciplinary Actions
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/employees/disciplinary-actions/view/${id}`">
                        <template v-if="action.disc_violation_id">{{ action.violation_name }}</template>
                        <template v-else>{{ action.other_violation_name }}</template>
                         on {{ action.disc_action_date | moment("MM/DD/YYYY") }} by {{ action.employee_first_name }} {{ action.employee_last_name }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active"><i class="fa fa-trash"></i> Delete</li>
            </ol>
        </h4>

        <div class="row mb-4">
            <div class="col-md-8">
                <div class="card mb-2">
                    <div class="card-body">
                        <div class="alert alert-danger">
                            <strong>Warning:</strong> You are about to permanently delete this disciplinary action and all it's files and signatures. This cannot be undone.
                        </div>
                    </div>
                </div>

                <div class="card mb-2">
                    <div class="card-header">
                        <strong>Files that will be deleted ({{ files.length }})</strong>
                    </div>
                    <div class="card-body">
                        <file-list :files="files" v-if="files.length > 0" />
                        <div v-else>-- None --</div>
                    </div>
                </div>

                <div class="card" v-if="incident">
                    <div class="card-header">
                        <strong>Incident Will Be Unlinked</strong>
                    </div>
                    <div class="card-body">
                        <p>The following incident will be unlinked from this discplinary action:</p>
                        <router-link :to="`/incidents/view/${incident.IncidentId}`">
                            <incident-name :incident="incident" />
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-danger" v-on:click="deleteAction()" :disabled="deleting" v-if="!loading">
            <span v-if="deleting">Deleting...</span>
            <span v-else>
                Delete
            </span>
            Disciplinary Action
        </button>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {

        data: function() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                action: {},
                files: [],
                incident: null,
                errors: {},
            }
        },

        computed: {

        },

        methods: {
            //Get the Action
            getAction(){
                //Send it
                this.$http.get('/employees/disciplinary-actions/view/' + this.id)
                    .then(res => {
                        //Set the resources
                        this.action = res.data.action;
                        this.files = res.data.files;
                        this.incident = res.data.incident;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Done loading
                        this.loading = false;
                    });
            },

            deleteAction(){
                //Done loading
                this.deleting = true;

                //Send it
                this.$http.post('/employees/disciplinary-actions/delete/' + this.id)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Disciplinary Action Deleted');

                        //Return to main list?
                        this.$router.push('/employees/disciplinary-actions');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Delete Disciplinary Action');
                        }
                    })
                    .then(() => {
                        //Done loading
                        this.deleting = false;
                    });
            },
        },

        mounted() {
            //Get the HSE
            this.getAction();
        }
    }
</script>
